import { FlexGrid, FlexGridItem, useStyletron } from "@mezo-org/mezo-clay"

import {
  selectIsConnected,
  selectUserHasLoan,
  useDappSelector,
} from "#/redux-state"

import {
  HomepageMainSectionAssetsDeposits,
  HomepageMainSectionAssetsMusd,
} from "../Homepage"

export default function OverviewUserAssets() {
  const isConnected = useDappSelector(selectIsConnected)
  const hasLoan = useDappSelector(selectUserHasLoan)

  const [, theme] = useStyletron()

  if (!isConnected) return null

  return (
    <FlexGrid
      flexGridColumnCount={[1, 1, 1, 2]}
      flexGridColumnGap={theme.sizing.scale500}
      flexGridRowGap={theme.sizing.scale500}
      paddingBottom={hasLoan ? 0 : theme.sizing.scale900}
    >
      <FlexGridItem>
        <HomepageMainSectionAssetsDeposits />
      </FlexGridItem>
      <FlexGridItem>
        <HomepageMainSectionAssetsMusd />
      </FlexGridItem>
    </FlexGrid>
  )
}
